export default __webpack_public_path__ + "static/media/science-tech.53bbcc4b.jpg";